"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = exports.removeNotification = exports.enqueueNotification = void 0;

var _toolkit = require("@reduxjs/toolkit");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var snackbarSlice = (0, _toolkit.createSlice)({
  name: 'snackbar',
  initialState: {
    notifications: []
  },
  reducers: {
    enqueueNotification: function enqueueNotification(state, action) {
      state.notifications.push(_objectSpread(_objectSpread({
        key: Math.random()
      }, action.payload), {}, {
        options: _objectSpread({
          dismissText: 'Close'
        }, action.payload.options)
      }));
    },
    removeNotification: function removeNotification(state, action) {
      var index = state.notifications.findIndex(function (notification) {
        return notification.key === action.payload;
      });
      if (index >= 0) state.notifications.splice(index, 1);
    }
  }
});
var _snackbarSlice$action = snackbarSlice.actions,
    enqueueNotification = _snackbarSlice$action.enqueueNotification,
    removeNotification = _snackbarSlice$action.removeNotification;
exports.removeNotification = removeNotification;
exports.enqueueNotification = enqueueNotification;
var reducer = snackbarSlice.reducer;
exports.reducer = reducer;